import { CreateNewReminderModal } from "./CreateNewReminderModal";

export default CreateNewReminderModal;
